import React from 'react';
import startCase from 'lodash/startCase';

import { NOTIFICATIONS_CHANNEL_OPTIONS } from 'data/NotificationsChannelOptions';
import Field from 'components/Field';
import ToggleChip from 'components/ToggleChip';

function SelectNotificationMode({ communications, handleCommsToggle }) {
  return (
    <Field
      label="Send Comms"
      className="m-t-m"
    >
      {Object.values(NOTIFICATIONS_CHANNEL_OPTIONS).map((commType) => (
        <ToggleChip
          key={commType}
          label={startCase(commType)}
          className="m-r-xs h4"
          isAdded={Boolean(communications[commType])}
          onRemove={() => {
            handleCommsToggle(commType);
          }}
          onAdd={() => {
            handleCommsToggle(commType);
          }}
        />
      ))}
    </Field>
  );
}

export default SelectNotificationMode;
